module.exports = __webpack_public_path__ + "14fc356a539822a4a54be0efd450abae.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-90@2x.png
// module id = 544
// module chunks = 0